@file:OptIn(ExperimentalUnsignedTypes::class)
@file:Suppress("UNUSED_PARAMETER")

package net.sergeych.ugdx.shared

import kotlinx.serialization.Serializable
import net.sergeych.kiloparsec.ExceptionWithCode
import net.sergeych.kiloparsec.RemoteInterface
import net.sergeych.ugdx.shared.ErrorCode.*

enum class ErrorCode {
    NOT_IMPLEMENTED,
    NOT_FOUND, INVALID_CONTEXT, BAD_SCK_KEY, POW_ERROR, MISSING_TSK, UNKNOWN_SERVICE_KEY, SESSION_NOT_FOUND,

    NOT_SIGNED_IN, INVALID_CREDENTIALS, RETRY_LOGIN, LOGIN_NAME_UNAVAILABLE, INVALID_INVITE_CODE,

    INVALID_PARAMETER, UNKNOWN_COMMAND, ACCESS_FORBIDDEN,

    INTERNAL_ERROR,

    INVALID_ETH_SIGNED_MESSAGE, INVALID_ETH_SIGNATURE, ADDRESS_IN_USE,
    INVALID_OPERATION, INSUFFICIENT_FUNDS,

    OPERATION_FORBIDDEN, INVALID_ORDER_SIGNATURE, INVALID_ORDER,
    INVALID_INVOICE,

    CONNECTION_FAILED;


    fun raise(text: String = "API Error: ${this.name}", reason: Throwable? = null): Nothing {
        throw ApiException(this, text, reason)
    }

    companion object {
        private val byCode by lazy {
            ErrorCode.entries.map { it.name.lowercase() to it }.toMap()
        }

        fun from(code: String): ErrorCode =
            byCode[code.trim().lowercase()] ?: throw IllegalArgumentException("invalid error code '$code'")
    }
}

val String.errorCode: ErrorCode get() = ErrorCode.from(this)


@Serializable
data class ErrorInfo(val code: ErrorCode, val text: String? = null) {
    val message by lazy {
        text?.let { "(${code.name}) $it" } ?: code.name
    }
}

open class ApiException(val info: ErrorInfo) :
    RemoteInterface.RemoteException(info.code.name, info.message), ExceptionWithCode {

    val errorCode: ErrorCode by lazy { ErrorCode.from(code) }

    constructor(code: ErrorCode, text: String? = null, reason: Throwable? = null)
            : this(ErrorInfo(code, text))

    companion object {

        fun notImplemented(): Nothing = NOT_IMPLEMENTED.raise()

        fun notFound(text: String = "object not found"): Nothing = NOT_FOUND.raise(text)

        fun invalidContext(text: String = "context is broken or outdated"): Nothing = INVALID_CONTEXT.raise(text)

        fun badSCKKey(): Nothing = BAD_SCK_KEY.raise("use correct key or request new one")
        fun powError(text: String): Nothing = POW_ERROR.raise(text)
        fun refreshTSK(): Nothing = MISSING_TSK.raise("negotiate new TSK")
        fun unknownServiceKey(): Nothing =
            UNKNOWN_SERVICE_KEY.raise("this service key is not known to us, try rescan it")

        fun sessionNotFound(): Nothing = SESSION_NOT_FOUND.raise("the session does not exit. request new one")

        fun notSignedIn(): Nothing = throw ApiException(NOT_SIGNED_IN, "sign in to the service to get access")
        fun internalError(text: String): Nothing = throw ApiException(INTERNAL_ERROR, text)

        fun invalidParameter(text: String): Nothing = throw ApiException(INVALID_PARAMETER, text)
        fun invalidCommand(name: String): Nothing = throw ApiException(UNKNOWN_COMMAND, "command not found: $name")

        fun throwIfKnown(code: String, text: String) {
            kotlin.runCatching { ErrorCode.valueOf(code) }.getOrNull()?.let {
                throw ApiException(it, text)
            }
        }
    }
}
